<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">
        Report - Summary Fixed Asset
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="5">
          <b-form-group label-cols="3" label="Group/Category">
            <b-form-select v-model="model.account" :plain="true" :options="accounts"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group label-cols="3" label="As Of Date">
            <b-row>
              <b-col class="pr-1" cols="6">
                <b-form-input v-model="model.tgl2" :state="!$v.model.tgl2.$error" type="date"></b-form-input>
              </b-col>
              <b-col class="pl-1" cols="6">
                <b-button class="btn btn-success" @click="getData()">
                  <i class="fa fa-play"></i> Process
                </b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
       <b-card no-body>
      <b-table
        class="mb-0"
        ref="tableOri"
        outlined
        responsive
        striped
        hover
        style="font-size:smaller;"
        :items="rptLines"
        :fields="tblFields"
        :current-page="tblfa.page"
        :per-page="tblfa.limit"
        :sort-by.sync="tblfa.sortBy"
        :sort-desc.sync="tblfa.sortDesc"
        :filter="filterInput"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        show-empty
      >
        <!-- <template v-slot:cell(asdesc)="data">
          <span v-if="(data.item.dispose==1)" style="color:#FFFF0000;">{{ data.item.asdesc }} (DISPOSE)</span>
          <span v-else>{{ data.item.asdesc }}</span>
        </template> -->
        <template v-slot:cell(otherinfo)="data">
          {{ data.item.brand }} {{ data.item.asmodel }}
          <span v-if="(data.item.asmodel)"> | {{ data.item.asmodel }}</span>
          <span v-if="(data.item.asserial)"> | {{ data.item.asserial }}</span>
          <span v-if="(data.item.otherinfo)"> | {{ data.item.otherinfo }}</span>
        </template>
        
        <template v-slot:cell(asdatacq)="data">
          <span v-if="(data.item.asdatacq)">{{ data.item.asdatacq | moment("DD-MMM-YYYY") }}</span>
        </template>
        <template v-slot:cell(aspurcpri)="data">
          {{ data.item.aspurcpri | numFormat('0,0.00') }}
        </template>
        <template v-slot:cell(tahunlalu)="data">{{ data.item.tahunlalu | numFormat('0,0.00') }}</template>
        <template v-slot:cell(bulanini)="data">{{ data.item.bulanini | numFormat('0,0.00') }}</template>
        <template v-slot:cell(tahunini)="data">{{ data.item.tahunini | numFormat('0,0.00') }}</template>
        <template v-slot:cell(saldoAk)="data">
          {{ data.item.saldoAk | numFormat('0,0.00') }}
        </template>
        <template v-slot:cell(aspurcpriTB)="data">{{ data.item.aspurcpriTB | numFormat('0,0.00') }}</template>
        <template v-slot:cell(akumTB)="data">{{ data.item.akumTB | numFormat('0,0.00') }}</template>
        <template v-slot:custom-foot="data">
            <b-tr>
              <b-td class="tebal" style="text-align:right" colspan="6"><strong>SUB TOTAL : &nbsp;</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totAcqValue | numFormat('0,0.00')}}</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totThnlalu | numFormat('0,0.00')}}</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totBlnIni | numFormat('0,0.00')}}</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totThnIni | numFormat('0,0.00')}}</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totSaldoAk | numFormat('0,0.00')}}</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totAcqTB | numFormat('0,0.00')}}</strong></b-td>
              <b-td class="total" style="text-align:right"><strong>{{summary.totAkumTB | numFormat('0,0.00')}}</strong></b-td>
            </b-tr>
          </template>
      </b-table>
      <b-row class="m-1">
        <b-col lg="6">            
          <b-row v-if="(filterShow=='Hide')">
                <b-input-group size="sm">
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                      <b-input-group-prepend> <span class="pr-2">
                          <b> {{ filterShow }}</b>  Filter </span>
                      </b-input-group-prepend>
                    <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group size="sm" class="ml-4">
                    <!-- <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                    </b-input-group-prepend> -->
                <b-form-checkbox-group v-model="filterOn" class="mt-1" >
                  <b-form-checkbox v-for="(item,index) in tblFields.filter(x=>x.filterable)" :key="index" :value="item.key">{{item.label}}</b-form-checkbox>
                  <b-form-checkbox :value="dispose">Dispose</b-form-checkbox>
                  <b-form-checkbox :value="brand">Brand</b-form-checkbox>
                  <b-form-checkbox :value="asmodel">Type/Model/Series</b-form-checkbox>
                  <b-form-checkbox :value="asserial">Serial Number</b-form-checkbox>
                  <b-form-checkbox :value="otherinfo">Other Info(No.Pol)</b-form-checkbox>
                </b-form-checkbox-group>
                </b-input-group>
                <!-- <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label> -->
          </b-row>
          <b-row v-else>
            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
              <b> {{ filterShow }}</b>  Filter
            </b-form-checkbox>
          </b-row>
        </b-col>
        <b-col lg="6">
          <div style="display: flex;margin:0;padding:0;">
              <div style="margin:0;padding:5px;width:500px; text-align:right;">
                  Showing {{(tblfa.page - 1) * tblfa.limit + 1}}
                  to <span v-if="((tblfa.page * tblfa.limit)>tblfa.total)">{{tblfa.total}}</span> <span v-else>{{tblfa.page * tblfa.limit}}</span>
                  of {{tblfa.total}} ,   <span class="mr-1">limit per page :</span> 
                  <input type="number" style="width:80px;" v-model="limit"/>
              </div>
              <div>
                  <b-pagination  class="ml-1" 
                    align="left"
                    :total-rows="tblfa.total"
                    :per-page="tblfa.limit"
                    v-model="tblfa.page"
                  ></b-pagination>
              </div>
          </div>
        </b-col>
      </b-row>
       </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>

iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}
</style>

<script>
import moment from "moment";
import fa_report from "../../apis/fa_report";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      // tgl1: { required },
      tgl2: { required }
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      summary: {
        tahunLalu: "Des 2018",
        tahunIni: "Jun 2019",
        bulanIni: "Jun 2019"
      },
      tblfa: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      limit:15,
      filterShow:'Show',
      filter: null,
      filterInput: null,
      filterOn: ['asdesc']
    };
  },
  components: { Loading },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
      return this.model.account;
    },
    tblFields() {
      const fields = [
        {
          key: "asetid",
          label: "FA. Number",
          sortable: true,
          filterable:true
        },
        {
          key: "asdesc",
          label: "FA. Name",
          sortable: true,
          filterable:true
        },
        {
          key: "otherinfo",
          label: "Other Info",
          sortable: true,
        },
        {
          key: "nodeliver",
          label: "Refer Doc#",
          thStyle: "width:90px",
          sortable: true,
          filterable:true
        },
        {
          key: "catgname",
          label: "Group/Category",
          sortable: true,
          filterable:true
        },
        {
          key: "masa",
          label: "Deprec. Period",
          thStyle: "width:90px",
          sortable: true,
        },
        {
          key: "asdatacq",
          label: "Aquisition Date",
          thStyle: "width:80px",
          sortable: true,
          filterable:true
        },
        {
          key: "aspurcpri",
          label: "Aquisition Value",
          thStyle: "width:80px",
          sortable: true,
          filterable:true,
          tdClass:'text-right'
        },
      ];
      fields.push(
        {
          key: "tahunlalu",
          label: `Accum. Depr. ${this.summary.tahunLalu}`,
          thStyle: "width:80px",
          sortable: true,
          tdClass:'text-right'
        },
        {
          key: "bulanini",
          label: `Depr. ${this.summary.bulanIni}`,
          thStyle: "width:80px",
          sortable: true,
          tdClass:'text-right'
        },
        {
          key: "tahunini",
          label: `Accum Depr. ${this.summary.bulanIni}`,
          thStyle: "width:80px",
          sortable: true,
          tdClass:'text-right'
        },
        {
          key: "saldoAk",
          label: "NETT VALUE",
          thStyle: "width:80px",
          sortable: true,
          tdClass:'text-right'
        },
        {
          key: "aspurcpriTB",
          label: `Saldo TB`,
          thStyle: "width:80px",
          sortable: true,
          tdClass:'text-right'
        },
        {
          key: "akumTB",
          label: "Saldo Akum.Depr TB",
          thStyle: "width:80px",
          sortable: true,
          tdClass:'text-right'
        }
      )
      return fields;
    }
  },
  watch: {
    account: function(newval) {
      const obj = this.accounts.find(d => d.value === newval);
      this.model.namaacc = obj.text || "";
      this.model.kodeacc = obj.kodeacc;
      // console.log(`${this.filter.account} | ${this.filter.namaacc}`);
    },
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },    
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 1000);
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblfa.limit=newVal;
        }
      }, 500);
    },       
  },  
  created: async function() {
    const accList = await fa_report.category();
    this.accounts = accList.reduce(
      (newArr, item) => {
        newArr.push(item);
        return newArr;
      },
      [{ value: "", text: "--- ALL ---" }]
    );
    const tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
      .add(1, "M")
      .subtract(1, "day");
    this.model.tgl1 = this.$store.state.user.tglaktif;
    this.model.tgl2 = tgl2.format("YYYY-MM-DD");
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblfa.total = filteredItems.length;
      this.tblfa.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    getData: async function(ctx) {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
            this.isLoading = true;
            const result = await fa_report.summary(this.model);
            this.rptLines = result[0];
            this.tblfa.total = result[0].length;
            this.summary = result[1][0];
            this.isLoading = false;
          } catch (error) {
                  this.isLoading=false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
              this.isLoading=false;            
          }
      }
    },
    // confirmAction: function() {
    //     toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    // },
    exportxls: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          await fa_report.summaryexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
        }
      }
    },
    close() {
      router.push("/payable/home");
    }
  }
};
</script>
